/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { Txt, Box } from '.'
import { Model } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/types'

export const UserProfilePicture: React.SFC<{
  width: number
  user: Model.User
  tableState?: Model.UserTableState
}> = ({ user, width, tableState, ...props }) => (
  <Box
    sx={{
      width,
      height: width,
      fontSize: width,
      borderRadius: 'pill',
      transition: 'border-color 1.5s linear',
      bg: 'darkBlue',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
    }}
    {...props}
  >
    {tableState === 'AWAY' && (
      <Box
        sx={{
          width,
          height: width,
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          bg: 'rgb(0, 0, 0, .7)',
          borderRadius: 'pill',
          color: 'white',
          lineHeight: '1',
          fontSize: '.3em',
        }}
      >
        Away
      </Box>
    )}
    <Txt sx={{ lineHeight: '1', fontSize: '.5em', color: 'white' }}>
      {user.email[0].toUpperCase()}
    </Txt>
  </Box>
)
